/**
 * Date and time format constants
 */

/**
 * Standard date-time format used across the application: YYYY-MM-DD HH:mm:ss
 */
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * ISO date-time format used for some backend responses: YYYY-MM-DDTHH:mm:ss
 */
export const ISO_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
